import * as reportService from "../../Service/Report.service";
let initialState = {
  reportMenus: [],
  activeReportMenu: {},
};

const state = { ...initialState };

const getters = {
  getReportMenus(state) {
    return state.reportMenus;
  },
  getActiveReportMenu(state) {
    return state.activeReportMenu;
  },
};

const mutations = {
  setActiveReportMenu(state, selectedReport) {
    state.activeReportMenu = selectedReport;
  },
  setReportMenus(state, reportMenuList) {
    state.reportMenus = reportMenuList;
  },
};

const actions = {
  async getAllReportMenus(context) {
    var result = await reportService.getAllReportMenus();

    if (result.error == false) {
      context.commit("setReportMenus", result.data);
    }
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
